const PREMIUM_SIX_MONTHS_IDENTIFIER = "org.pilone.iHomework2.products.premium6months";
const PREMIUM_TWELVE_MONTHS_IDENTIFIER = "org.pilone.iHomework2.products.premium12months";
const X_PREMIUM_SIX_MONTHS_IDENTIFIER = "org.pilone.iHomework2Mac.products.premium6months";
const X_PREMIUM_TWELVE_MONTHS_IDENTIFIER = "org.pilone.iHomework2Mac.products.premium12months";

export default {

  getProductTitle(productId) {
    var title = "";
    if (productId === PREMIUM_SIX_MONTHS_IDENTIFIER
        || productId === X_PREMIUM_SIX_MONTHS_IDENTIFIER) {
      title = "6 Months";
    } else if (productId === PREMIUM_TWELVE_MONTHS_IDENTIFIER
        || productId === X_PREMIUM_TWELVE_MONTHS_IDENTIFIER) {
      title = "1 Year";
    }

    return title;
  }

}


// WEBPACK FOOTER //
// ./src/services/products.js